// removed by extract-text-webpack-plugin
module.exports = {"linkIsButton":"_25azbLDwh-xFzmw33NyISl","linkLabel":"_2hWtdVzvspYjDVnDBfgdzH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Link/styles.css
// module id = 295
// module chunks = 0